import React from 'react';
import './VideoLoader.css';

interface ContainerProps {
  isLoading: boolean;
}

const VideoLoader: React.FC<ContainerProps> = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }
  return (
    <div id={`overlay`}>
      <div className={'loading-wrapper'}>
        <div className="lds-roller">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  );
};

export default VideoLoader;
